import React from "react";
import VideoPreview from "@src/components/Tabs/Content/components/VideoPreview";

const VideoPreviewPage = () => {
  return <VideoPreview />;
};

// DEFINING LAYOUT PROPERTIES FOR THIS PAGE
VideoPreviewPage.getLayoutProps = () => ({
  blockHeader: true,
  noPullToRefresh: true,
});

export default VideoPreviewPage;
